<template>
  <div class="list-item-content"
       :class="categoryStyles">
    <div class="list-item-content-title one-liner">
      {{ category.description | category }}
    </div>

    <base-btn-group :state="state"
                    button-allow
                    button-warn
                    button-block
                    @click="changeAction" />
  </div>
</template>

<script>

  export default {
    props: {
      category: {
        type: Object,
        required: true
      },

      childId: {
        type: String,
        required: true
      }
    },

    data: () => ({
      state: null
    }),

    created() {
      this.initState()
    },

    computed: {
      ...mapGetters('children', {
        getCategorySettings: 'getCategorySettings'
      }),

      categorySettings() {
        return this.getCategorySettings(this.childId)
      },

      setting() {
        return this.categorySettings.find(setting => setting.category_id === this.category.id)
      },

      categoryStyles() {
        return {
          'category-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      initState() {
        this.state = this.setting ? this.setting.action : 'allow'
      },

      changeAction(action) {
        this.$emit('changeAction', {
          ...this.category,
          action
        })
      }
    },

    watch: {
      categorySettings() {
        this.initState()
      }
    }
  }
</script>

